import { Environment } from './environment.interface';

/**
 * Environment variable configuration for production
 */
export const environment: Environment = {
  production: true,
  api: 'https://api.hunter.cyborgsecurity.io',
  calendlyUrl:
    'https://calendly.com/cyborgexperts/30min?hide_gdpr_banner=1&primary_color=02ade6',
  verity: {
    auth0Url: 'https://intel471-dev.us.auth0.com/',
    devUrl: 'https://merlin-ui.dev.intel471.cloud',
    stagingUrl: 'https://merlin-ui.staging.intel471.cloud',
    prodUrl: 'https://verity.intel471.com',
  },  
  tracking: {
    enabled: true,
    trackers: {
      elastic: {
        serviceName: 'hunter-portal-frontend',
        serverUrl:
          'https://211cacf861bf426e8efe42151841c466.apm.us-east-1.aws.cloud.es.io',
        environment: 'production',
        active: true,
        breakdownMetrics: true,
        logLevel: 'error',
        distributedTracingOrigins: [
          'https://hunter.cyborgsecurity.io',
          'https://api.hunter.cyborgsecurity.io',
        ],
      },
      fullstory: {
        orgId: '1453KT',
      },
      churnzero: {
        appKey: '1!oZHPc4uS8We8D2AhNBNtdOb-bsVlv3vgGbTPnMLPY-st1548',
      },
    },
  },
};
